<template>
    <el-pagination
        background :total="pagination.total" :current-page="pagination.pageIndex" :pager-count="11"
        :page-sizes="sizeRange ?? [12, 24, 30, 48, 60, 78]" :page-size="pagination.pageSize"
        layout="prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        class="pagination"
    />
</template>
<script lang="ts" setup>
const props = defineProps({
    total: {
        type: Number,
        default: 0
    },
    pageIndex: {
        type: Number,
        default: 1
    },
    pageSize: {
        type: Number,
        default: 30
    },
    sizeRange: {
        type: Array
    },
    fetch: {
        type: Function,
        default: function () { }
    }
});

const pagination = reactive({
    pageIndex: 1,
    pageSize: 30,
    total: 0
});

watch(() => props.pageIndex, (val) => {
    pagination.pageIndex = val;
}, { immediate: true });

watch(() => props.pageSize, (val) => {
    pagination.pageSize = val;
}, { immediate: true });

watch(() => props.total, (val) => {
    pagination.total = val;
}, { immediate: true });

const handleSizeChange = (val: number) => {
    pagination.pageSize = val;
    props.fetch(pagination);
};

const handleCurrentChange = (val: number) => {
    pagination.pageIndex = val;
    props.fetch(pagination);
};
</script>

<style lang="scss" scoped>
.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;

    :deep() {

        .btn-prev,
        .btn-next {
            background-color: #fff;
            border: 0.5px solid #ccc;
        }

        .number {
            color: #666666 !important;
            background-color: #fff !important;
            border: 0.5px solid #ccc;
        }

        .is-active {
            color: #1a1a1a !important;
            background: $themeColor !important;
        }

        .el-pagination__sizes {
            .el-select__wrapper {
                box-shadow: 0 0 0 0.5px #ccc inset;
            }

            .el-select {
                width: 112px;
            }
        }

        .el-pagination__jump {
            .el-pagination__editor {
                .el-input__wrapper {
                    box-shadow: 0 0 0 0.5px #cccccc inset;
                }
            }
        }
    }
}
</style>
